import { render } from "./CalendarEventAttendeesList.vue?vue&type=template&id=7b63c924&scoped=true"
import script from "./CalendarEventAttendeesList.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeesList.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendeesList.vue?vue&type=style&index=0&id=7b63c924&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b63c924"

export default script